import router, {Route} from "@/routing/Router";
import {IconType} from "peggirkit";
import {IntlShape} from "react-intl";
import {
    BriefcaseIcon,
    BuildingStorefrontIcon,
    ChartPieIcon,
    ClockIcon,
    ComputerDesktopIcon,
    DocumentTextIcon,
    HomeIcon,
    MapIcon,
    PlayPauseIcon,
    PresentationChartBarIcon,
    ServerStackIcon,
    SparklesIcon,
    TicketIcon,
    UsersIcon,
} from "@heroicons/react/24/outline";
import BusyIndication from "@widgets/busyness/indication/BusyIndication";
import UnreadContactFormsBadge from "@widgets/jobApplications/menuIndicator/OpenJobApplicationsBadge";

export type MenuSection = {
    name?: (intl: IntlShape) => string,
    items: MenuItem[],
    excludeInParentOverview?: boolean,
};

export type MenuItem = {
    icon?: IconType,
    after?: () => JSX.Element,
    excludeInParentOverview?: boolean,
} & ({
    route: Route,
} | {
    name: string,
    href: string,
});

export const reportsMenuSection: MenuSection = {
    name: intl => intl.formatMessage({id: "reports"}),
    items: [
        {
            route: router.reports,
            icon: ChartPieIcon,
            excludeInParentOverview: true,
        },
        {
            route: router.dayReport,
            icon: PresentationChartBarIcon,
        },
        {
            route: router.timesheet,
            icon: ClockIcon,
        },
    ]
};

export const posMenuSections: MenuSection[] = [
    {
        name: intl => intl.formatMessage({id: "general"}),
        items: [
            {
                route: router.posAdminDashboardHome,
                icon: HomeIcon,
                excludeInParentOverview: true,
            },
            {
                route: router.posDashboardHome,
                icon: ComputerDesktopIcon,
            },
        ],
    },
];

export const adminMenuSections: MenuSection[] = [
    {
        name: intl => intl.formatMessage({id: "general"}),
        items: [
            {
                route: router.adminHome,
                icon: HomeIcon,
            },
            {
                route: router.systemInfo,
                icon: ServerStackIcon,
            },
        ],
        excludeInParentOverview: true,
    },
    {
        name: intl => intl.formatMessage({id: "location"}),
        items: [
            {
                route: router.deliveryAreas,
                icon: MapIcon,
            },
            {
                route: router.busynessManagement,
                icon: PlayPauseIcon,
                after: BusyIndication,
            },
            {
                route: router.location,
                icon: BuildingStorefrontIcon,
            },
            {
                route: router.employees,
                icon: UsersIcon,
            },
            {
                route: router.loyaltyRewards,
                icon: TicketIcon,
            },
            {
                route: router.featuredProducts,
                icon: SparklesIcon,
            },
        ]
    },
    {
        name: intl => intl.formatMessage({id: "workAt"}),
        items: [
            {
                route: router.jobOpenings,
                icon: BriefcaseIcon,
            },
            {
                route: router.jobApplications,
                icon: DocumentTextIcon,
                after: UnreadContactFormsBadge,
            },
        ]
    },
    // {
    //     name: intl => intl.formatMessage({id: "sitedish"}),
    //     items: [
    //         {
    //             route: router.synchronization,
    //             icon: ArrowsRightLeftIcon,
    //         },
    //     ]
    // },
    reportsMenuSection,
    {
        name: intl => intl.formatMessage({id: "external"}),
        items: [
            {
                name: "Medewerkers",
                href: router.employeeEnvironment.absolutePath(),
            },
            {
                name: "Eataliano.nl",
                href: "https://eataliano.nl/",
            },
            {
                name: "Documentatie",
                href: "https://eataliano.docs.peggir.com/",
            },
        ]
    },
];
